<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_vi"></a><a id="Copyright">Published by<br/>
Grub Street Publishing<br/>
4 Rainham Close<br/>
London<br/>
SW11 6SS</a></p><a id="Copyright">
<p class="copyright3">Copyright © Grub Street 2012<br/>
Copyright text © Richard Pike 2012</p>
<p class="copyright3"><b>British Library Cataloguing in Publication Data</b><br/><br/>
Pike, Richard, 1943-<br/>
   Alfie's War: A Fleet Air Arm Officer's exciting exploits on<br/>
   HMS <i>Illustrious</i>, in Greece and Crete.<br/>
   1. Sutton, A. W. F. (Alan William Frank)<br/>
   2. Great Britain. Royal Navy. Fleet Air Arm–History.<br/>
   3. World War, 1939-1945–Naval operations, British.<br/>
   I. Title<br/>
   940.5'45'941'092-dc23<br/><br/>
   <b>ISBN-13: 9781908117410<br/>
   EPUB ISBN: 9781909166332</b></p>
<p class="copyright3">All rights reserved. No part of this publication may be<br/>
reproduced, stored in a retrieval system, or transmitted<br/>
in any form or by any means electronic, mechanical,<br/>
photocopying, recording, or otherwise, without the prior<br/>
permission of the copyright owner.</p>
<p class="copyright3">Edited by Sophie Campbell</p>
</a><p class="copyright3"><a id="Copyright">Book design and artwork by Roy Platten, Eclipse<br/>
</a><a href="mailto:roy.eclipse@btopenworld.com">roy.eclipse@btopenworld.com</a></p>
<p class="copyright3">Printed and bound by MPG Ltd, Bodmin, Cornwall</p>
<p class="copyright3">Grub Street Publishing uses only FSC (Forest Stewardship<br/>
Council) paper for its books.</p>
<p class="copyright3">Publisher’s Note: Captain A W F ‘Alfie’ Sutton referred to himself<br/>
as the lieutenant, and we have kept this style throughout.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?72403ba8